import React from 'react'
import styled from 'styled-components'
import { Button, theme } from 'pcln-design-system'

const StyledButton = styled(Button)<{
  animatedBoxShadow: string
  scale: number
}>`
  &:hover {
    transform: scale(${props => props.scale});
    box-shadow: ${props => props.animatedBoxShadow};
    transition: 0.2s ease-in-out;
  }
`

function FindYourDealButton({
  formButtonProps,
  hasMinWidth,
  isLargeInput,
  buttonText
}: {
  buttonText: string
  formButtonProps?: Record<string, unknown>
  hasMinWidth?: boolean
  isLargeInput?: boolean
}) {
  return (
    <StyledButton
      m={0}
      width={1}
      size="large"
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      scale={theme.scale['scale-100'] + theme.scale['scale-2']}
      animatedBoxShadow={theme.shadows.xl}
      style={{
        whiteSpace: 'nowrap',
        minWidth: hasMinWidth ? '165px' : undefined,
        height: isLargeInput ? '56px' : undefined
      }}
      {...formButtonProps}
    >
      {buttonText}
    </StyledButton>
  )
}

export default FindYourDealButton
